import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { getValue, setValue } from "@utils/lodash";
import Notfound from "@components/Not-Found-small";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import {
	clientGetFunction,
	clientGetLocation,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { NavLink } from "react-router-dom";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
	getChildEntityGroups,
	getEntityGroups,
} from "@services/entity-mapping.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { adminGetUsers } from "@services/users.service";
import { addSelfComplianceList } from "@services/self-compliance.service";
import SimpleReactValidator from "simple-react-validator";

export default function CheckpointAssignTask(props: any) {
	let params = useParams();
	let navigate = useNavigate();

	const simpleValidator = useRef(new SimpleReactValidator());
	const [, forceUpdate] = useState(0);
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const [selectedLocation, setSelectedLocation] = useState<any>({});
	const [submitLoading, setSubmitLoading] = useState(false);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getHeaderList(paramsObj, 0);
			getExecutorList("");
			getEvaluator("");
			getFunctionHead("");
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			getHeaderList(paramsObj, 0);
			getExecutorList("");
			getEvaluator("");
			getFunctionHead("");

			// getEntityList();
		}
	}, [window.location.href, props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const [headerList, setHeaderList] = useState([]);
	const [headerLoading, setHeaderLoading] = useState(true);
	const [levelObj, setLevelObj] = useState<any>({});
	const [paramsObj, setParamsObj] = useState<any>({});

	const getHeaderList = async (paramsObj: any, index: number) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			status: params.status ? params.status : "",
			sort_by: params.sort_by,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			let resp = await getEntityGroups(queryRequest);
			if (resp) {
				setHeaderList(getValue(resp, `data.entityGroups`, []));
				var result: any = {};
				for (
					let i = 0;
					i < getValue(resp, `data.entityGroups.length`, 0);
					i++
				) {
					result[
						`${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
					] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
				}
				if (Object.keys(levelObj).length === 0) {
					for (let x in result) {
						let keys = Object.keys(result[x])[0];
						levelObj[keys] = {};
					}
				}
				// delete params[`checkpoint_id[]`];
				let list =
					Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
				if (getValue(list, `length`, 0) > 0) {
					list.map((item: any, _index: number) => {
						let findNextLevelInfo = getValue(
							resp,
							`data.entityGroups`,
							[]
						).filter(
							(ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
						);
						if (_index === index)
							return getEntityList(
								getValue(findNextLevelInfo, `[${0}].id`, ""),
								item.split("_")[0],
								"",
								index
							);
					});
				} else {
					getEntityList(
						getValue(resp, `data.entityGroups[${0}].id`, ""),
						null,
						"",
						index
					);
				}
				setHeaderLoading(false);
			} else {
				setHeaderLoading(false);
			}
		} catch (error) {
			setHeaderLoading(false);
		}
	};

	const getEntityGroupsUponSelection = async (
		paramsObj: object,
		index: number
	) => {
		let list =
			Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
		if (getValue(list, `length`, 0) > 0) {
			list.map((item: any, _index: number) => {
				let findNextLevelInfo = headerList.filter(
					(ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
				);
				if (_index === index)
					return getEntityList(
						getValue(findNextLevelInfo, `[${0}].id`, ""),
						item.split("_")[0],
						"",
						index
					);
			});
		}
	};
	const [childEntityList, setChildEntityList] = useState<any>({});
	const [childEntityLoading, setChildEntityLoading] = useState(false);
	const getEntityList = async (
		id: string,
		entity_parent: any,
		search_text: string,
		index: number
	) => {
		if (id) {
			let payload = {
				entity_group: id,
				entity_parent: entity_parent,
				limit: 10,
				search_text: search_text,
			};
			let queryRequest = QueryRequestHelper(payload);
			setChildEntityLoading(true);
			try {
				let resp = await getChildEntityGroups(queryRequest);
				if (resp) {
					levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
						(item: any) => ({
							...item,
							value: getValue(item, `entity_name`, ""),
							label: getValue(item, `entity_name`, ""),
						})
					);
					setLevelObj({ ...levelObj });
					setChildEntityLoading(false);
				} else {
					setChildEntityLoading(false);
				}
			} catch (error) {
				setChildEntityLoading(false);
			}
		} else {
			// toast.error("You have Reached Maximum Levels");
		}
	};
	const handleClickEntity = (
		entity_id: any,
		group_id: any,
		group_level: any,
		headerIndex: number
	) => {
		//user selected level
		let userLevel = `${entity_id}_${group_id}_${group_level}`;
		let payload = { ...paramsObj };
		let selectedLevels =
			Object.values(payload).length > 0 ? Object.values(payload) : [];
		if (!selectedLevels.includes(userLevel)) {
			// appending child entity list that are presented in URL Params
			var result = Object.entries(childEntityList);
			var myNewArray: any =
				getValue(result, `length`, 0) > 0
					? result.filter(function (item, index) {
							return index + 1 <= group_level;
					  })
					: [];
			let obj: any = {};
			if (getValue(myNewArray, `length`, 0) > 0) {
				myNewArray.map((item: any) => {
					obj[item[0]] = item[1];
				});
			}
			setChildEntityList(obj);

			//deleting params if grater then current level selected by the user
			for (let i = group_level + 1; i < 10; i++) {
				delete paramsObj[`level${i}`];
			}

			// replacing url param if it have same group level / else we can add new one
			let checkIfAlreadyExist =
				Object.keys(payload).length > 0
					? Object.keys(payload).includes(`level${group_level}`)
					: false;
			if (checkIfAlreadyExist) {
				delete paramsObj[`level${group_level}`];
				let obj = {
					...paramsObj,
					[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
				};
				setParamsObj(obj);
				getEntityGroupsUponSelection(obj, headerIndex);
			} else {
				let obj = {
					...paramsObj,
					[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
				};
				setParamsObj(obj);
				getEntityGroupsUponSelection(obj, headerIndex);
			}
		} else {
			// toast.error("Already selected");
		}
	};
	const handleChange = (
		val: string,
		entity_group: string,
		parent_level: any,
		index: number
	) => {
		let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
			? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
					"_"
			  )[0]
			: null;

		if (!val) {
			getEntityList(entity_group, entityID, "", index);
			let length = Object.keys(paramsObj).length;
			for (let i = parent_level; i <= length; i++) {
				let id =
					paramsObj[`level${i + 1}`] &&
					paramsObj[`level${i + 1}`].split("_")[1];
				if (id) {
					levelObj[id] = {};
				}
				delete paramsObj[`level${i}`];
			}
			let obj = {
				...paramsObj,
			};
			setParamsObj(obj);
			getHeaderList(obj, index);
		} else {
			getEntityList(entity_group, entityID, val, index);
		}
	};
	/* -----------------------------  Executor  ------------------------------ */

	const [executorList, setExecutorList] = useState([]);
	const [executorLoading, setExecutorLoading] = useState(false);
	const [selectedExecutor, setSelectedExecutor] = useState<any>("");
	const getExecutorList = async (search: string) => {
		try {
			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
			let payload: any = {
				page_no: 1,
				page_size: 10,
				search_text: search,
				user_type: "CLIENT",
				org_id: getValue(user, `org_id`, ""),
			};
			let queryRequest = QueryRequestHelper(payload);
			setExecutorLoading(true);
			let resp = await adminGetUsers(queryRequest);
			if (resp) {
				setExecutorLoading(false);
				setExecutorList(
					getValue(resp, `data.users`, []).map((item: any) => ({
						...item,
						value:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
						label:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
					}))
				);
			} else {
				setExecutorLoading(false);
			}
		} catch (error) {
			setExecutorLoading(false);
		}
		if (!search) {
			setSelectedExecutor("");
		}
	};

	/* --------------------------------  Evaluator  ------------------------------ */
	const [evaluatorList, setEvaluatorList] = useState([]);
	const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
	const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
	const getEvaluator = async (search: string) => {
		try {
			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
			let payload: any = {
				page_no: 1,
				page_size: 10,
				search_text: search,
				user_type: "CLIENT",
				org_id: getValue(user, `org_id`, ""),
			};
			let queryRequest = QueryRequestHelper(payload);
			setEvaluatorLoading(true);
			let resp = await adminGetUsers(queryRequest);
			if (resp) {
				setEvaluatorLoading(false);
				setEvaluatorList(
					getValue(resp, `data.users`, []).map((item: any) => ({
						...item,
						value:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
						label:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
					}))
				);
			} else {
				setEvaluatorLoading(false);
			}
		} catch (error) {
			setEvaluatorLoading(false);
		}
		if (!search) {
			setSelectedEvaluator("");
		}
	};
	/* -----------------------------  FunctionHead  ------------------------------ */
	const [FunctionHead, setFunctionHead] = useState([]);
	const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
	const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
	const getFunctionHead = async (search: string) => {
		try {
			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
			let payload: any = {
				page_no: 1,
				page_size: 10,
				search_text: search,
				user_type: "CLIENT",
				org_id: getValue(user, `org_id`, ""),
			};
			let queryRequest = QueryRequestHelper(payload);
			setFunctionHeadLoading(true);
			let resp = await adminGetUsers(queryRequest);
			if (resp) {
				setFunctionHeadLoading(false);
				setFunctionHead(
					getValue(resp, `data.users`, []).map((item: any) => ({
						...item,
						value:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
						label:
							getValue(item, `first_name`, "") +
							" " +
							getValue(item, `last_name`, ""),
					}))
				);
			} else {
				setFunctionHeadLoading(false);
			}
		} catch (error) {
			setFunctionHeadLoading(false);
		}
		if (!search) {
			setSelectedFunctionHead("");
		}
	};

	/* -----------------------------  Submit  ------------------------------ */

	const handleSubmit = async () => {
		const formValid = simpleValidator.current.allValid();
		if (!formValid) {
			simpleValidator.current.showMessages();
			forceUpdate(1);
		} else {
			const urlSearchParams = new URLSearchParams(window.location.search);
			let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
			let lengthOfLevels = Object.keys(paramsObj).length;
			let levelObj: any = {};
			for (let i = 0; i < lengthOfLevels; i++) {
				levelObj[`level_${i + 1}`] = paramsObj[`level${i + 1}`]
					? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
					: "";
			}
			try {
				let payload = {
					checkpoint_ids: selectedIDs,
					executor: getValue(selectedExecutor, `id`, ""),
					evaluator: getValue(selectedEvaluator, `id`, ""),
					function_head: getValue(selectedFunctionHead, `id`, ""),
				};
				setSubmitLoading(true);
				let resp = await addSelfComplianceList({ ...payload, ...levelObj });
				if (resp) {
					toast.success(getValue(resp, `message`, ""));
					setSubmitLoading(false);
					navigate(`/repository/checkpoint/assigned-tasks`);
				} else {
					setSubmitLoading(false);
				}
			} catch (error) {
				setSubmitLoading(false);
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const handleReset = () => {
		setParamsObj({});
		setSelectedExecutor("");
		setSelectedEvaluator("");
		setSelectedFunctionHead("");
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	const urlParams = Object.fromEntries(urlSearchParams.entries());

	let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
	return (
		<>
			<Layout>
				{!headerLoading &&
				!getValue(props, `subTabPermissionList`, []).includes(
					"repository_checkpoint_assigned_tasks"
				) ? (
					<NoAccessPage />
				) : (
					<>
						<div className="common-sticky-header">
							<section className="inner-page-navigation-with-back-cta-buttons position-relative">
								<div className="container-fluid  d-flex justify-content-between align-items-center">
									<div className="d-flex align-items-center">
										<NavLink to="/repository/checkpoint/master">
											<img
												src="/images/back-link.svg"
												className="img-fluid"
												height={24}
												width={24}
											/>
										</NavLink>
										<p className="inner-page-navigation-text py-3">
											Assign Task
										</p>
									</div>
								</div>
							</section>
						</div>
						<div className="release-checkpoint  d-flex justify-content-between align-items-center checkpoint-assigned-task-sticky-header">
							<h4>Selected {getValue(selectedIDs, `length`, 0)} Checkpoints</h4>
							{getValue(props, `permissions`, []).includes("update") && (
								<div>
									<button
										className="ascent-button ascent-button--header-buttons ascent-button--primary"
										onClick={handleReset}
									>
										{"Reset"}
									</button>
									&nbsp;&nbsp;
									<button
										className="ascent-button ascent-button--header-buttons ascent-button--secondary"
										onClick={handleSubmit}
										disabled={submitLoading}
									>
										{submitLoading ? "Please wait..." : "Assign"}
									</button>
								</div>
							)}
						</div>
						{
							<>
								{/* Step 1 */}
								<div className="map-vendor-wrapper w-100">
									<div className="map-vendor__details d-flex align-items-flex-start m-0">
										<div className="map-vendor__check">
											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
													Step 1
												</h5>
												<div className="form-group d-flex align-iems-center m-0"></div>
											</div>
											<div className="map-vendor__checklist my-3">
												{headerLoading || !props.permissionAPITriggered ? (
													<Loader />
												) : getValue(headerList, `length`, 0) > 0 ? (
													headerList.map((searchObj, index) => {
														let selectedLevel =
															getValue(searchObj, `group_level`, 0) > 0
																? getValue(
																		paramsObj,
																		`level${parseInt(
																			getValue(searchObj, `group_level`, "")
																		)}`,
																		""
																  )
																: "";
														let currentSelectedItem =
															selectedLevel.split("_")[0];
														let selectedValue =
															getValue(
																levelObj,
																`[${getValue(searchObj, `id`, "")}].length`,
																[]
															) > 0 &&
															getValue(
																levelObj,
																`[${getValue(searchObj, `id`, "")}]`,
																[]
															).filter(
																(item: any) =>
																	item.id === parseInt(currentSelectedItem)
															);
														return (
															<>
																<div className={`d-flex cursor-pointer`}>
																	<div
																		className="position-relative form-group  align-items-center cursor-pointer mb-0"
																		key={`location-${index}`}
																	>
																		<div>
																			{getValue(searchObj, `group_name`, "")}
																		</div>
																		<div>
																			<div className="filter-form-wrappper__location-input">
																				<SearchableDropdownSelect
																					placeholder={`Choose ${getValue(
																						searchObj,
																						`group_name`,
																						""
																					)}`}
																					options={getValue(
																						levelObj,
																						`[${getValue(
																							searchObj,
																							`id`,
																							""
																						)}]`,
																						[]
																					)}
																					searchLoading={false}
																					handleChange={(val: any) =>
																						handleChange(
																							val,
																							getValue(searchObj, `id`, ""),
																							getValue(
																								searchObj,
																								`group_level`,
																								""
																							),
																							index
																						)
																					}
																					handleClick={(e: any) =>
																						handleClickEntity(
																							getValue(e, `id`, ""),
																							getValue(searchObj, `id`, ""),
																							getValue(
																								searchObj,
																								`group_level`,
																								""
																							),
																							index
																						)
																					}
																					value={
																						getValue(
																							selectedValue,
																							`length`,
																							0
																						) > 0
																							? selectedValue[0]
																							: ""
																					}
																					label="label"
																					id="id"
																					name={getValue(
																						searchObj,
																						`group_name`,
																						""
																					)}
																					// removeClose
																					validator={simpleValidator}
																				/>
																			</div>
																		</div>
																	</div>
																</div>
																<br />
															</>
														);
													})
												) : (
													<>
														{Object.keys(params).length !== 0 ? (
															<>
																<Notfound />
															</>
														) : (
															<Notfound />
														)}
													</>
												)}
											</div>
										</div>
										{/* Step 2 */}
										<div className="map-vendor__check">
											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
													Step 2
												</h5>
												<div className="form-group d-flex align-iems-center m-0"></div>
											</div>
											<div className=" my-3">
												<div className=" d-flex">
													<div className="position-relative form-group  align-items-center cursor-pointer mb-0">
														<div>
															<label>Executor *</label>
															<SearchableDropdownSelect
																placeholder={"Search Executor"}
																options={executorList}
																searchLoading={executorLoading}
																handleChange={(val: any) =>
																	getExecutorList(val)
																}
																handleClick={(e: any) => setSelectedExecutor(e)}
																value={selectedExecutor}
																label="label"
																id="id"
																name="Executor"
																validator={simpleValidator}
															/>
														</div>
														<br />
														<div>
															<label>Evaluator *</label>
															<SearchableDropdownSelect
																placeholder={"Search Evaluator"}
																options={evaluatorList}
																searchLoading={EvaluatorLoading}
																handleChange={(val: any) => getEvaluator(val)}
																handleClick={(e: any) =>
																	setSelectedEvaluator(e)
																}
																value={selectedEvaluator}
																label="label"
																id="id"
																name="Evaluator"
																validator={simpleValidator}
															/>
														</div>
														<br />
														<div>
															<label>Function Head *</label>
															<SearchableDropdownSelect
																placeholder={"Search Function Head"}
																options={FunctionHead}
																searchLoading={FunctionHeadLoading}
																handleChange={(val: any) =>
																	getFunctionHead(val)
																}
																handleClick={(e: any) =>
																	setSelectedFunctionHead(e)
																}
																value={selectedFunctionHead}
																label="label"
																id="id"
																name="Function Head"
																validator={simpleValidator}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="footer-wrapper-new w-100">
									<img
										src="/images/footer-image.svg"
										className="img-fluid footer-image"
									/>
								</div>
							</>
						}
					</>
				)}
			</Layout>
		</>
	);
}

//----------------- OLD CODE ---------------//

// export default function CheckpointAssignTask(props: any) {
// 	let params = useParams();
// 	let navigate = useNavigate();

// 	const simpleValidator = useRef(new SimpleReactValidator());
// 	const [, forceUpdate] = useState(0);
// 	/* -------------------------------------------------------------------------- */
// 	/*                               UseState Section                             */
// 	/* -------------------------------------------------------------------------- */
// 	const [selectedLocation, setSelectedLocation] = useState<any>({});
// 	const [submitLoading, setSubmitLoading] = useState(false);

// 	/* -------------------------------------------------------------------------- */
// 	/*                               UseEffect Section                            */
// 	/* -------------------------------------------------------------------------- */

// 	useEffect(() => {
// 		const urlSearchParams = new URLSearchParams(window.location.search);
// 		const params = Object.fromEntries(urlSearchParams.entries());
// 		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
// 			getHeaderList(paramsObj, 0);
// 			getExecutorList("");
// 			getEvaluator("");
// 			getFunctionHead("");
// 		}
// 	}, [props.permissionAPITriggered]);

// 	useEffect(() => {
// 		const urlSearchParams = new URLSearchParams(window.location.search);
// 		const params = Object.fromEntries(urlSearchParams.entries());
// 		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
// 			getHeaderList(paramsObj, 0);
// 			getExecutorList("");
// 			getEvaluator("");
// 			getFunctionHead("");

// 			// getEntityList();
// 		}
// 	}, [window.location.href, props.permissionAPITriggered]);

// 	/* -------------------------------------------------------------------------- */
// 	/*                               API Section                                  */
// 	/* -------------------------------------------------------------------------- */

// 	const [headerList, setHeaderList] = useState([]);
// 	const [headerLoading, setHeaderLoading] = useState(true);
// 	const [levelObj, setLevelObj] = useState<any>({});
// 	const [paramsObj, setParamsObj] = useState<any>({});

// 	const getHeaderList = async (paramsObj: any, index: number) => {
// 		const urlSearchParams = new URLSearchParams(window.location.search);
// 		const params = Object.fromEntries(urlSearchParams.entries());
// 		let payload: any = {
// 			status: params.status ? params.status : "",
// 			sort_by: params.sort_by,
// 		};
// 		let queryRequest = QueryRequestHelper(payload);
// 		try {
// 			let resp = await getEntityGroups(queryRequest);
// 			if (resp) {
// 				setHeaderList(getValue(resp, `data.entityGroups`, []));
// 				var result: any = {};
// 				for (
// 					let i = 0;
// 					i < getValue(resp, `data.entityGroups.length`, 0);
// 					i++
// 				) {
// 					result[
// 						`${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
// 					] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
// 				}
// 				if (Object.keys(levelObj).length === 0) {
// 					for (let x in result) {
// 						let keys = Object.keys(result[x])[0];
// 						levelObj[keys] = {};
// 					}
// 				}
// 				// delete params[`checkpoint_id[]`];
// 				let list =
// 					Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
// 				if (getValue(list, `length`, 0) > 0) {
// 					getEntityList(
// 						getValue(paramsObj, `level1`, "").split("_")[1],

// 						`level${getValue(
// 							resp,
// 							`data.entityGroups[${0}].group_level`,
// 							""
// 						)}` === `level1`
// 							? ""
// 							: getValue(paramsObj, `level1`, "").split("_")[0],
// 						""
// 					);
// 					list.map((item: any, _index: number) => {
// 						let findNextLevelInfo = getValue(
// 							resp,
// 							`data.entityGroups`,
// 							[]
// 						).filter(
// 							(ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
// 						);
// 						return getEntityList(
// 							getValue(findNextLevelInfo, `[${0}].id`, ""),
// 							item.split("_")[0],
// 							""
// 						);
// 					});
// 				} else {
// 					getEntityList(
// 						getValue(resp, `data.entityGroups[${0}].id`, ""),
// 						null,
// 						""
// 					);
// 				}
// 				setHeaderLoading(false);
// 			} else {
// 				setHeaderLoading(false);
// 			}
// 		} catch (error) {
// 			setHeaderLoading(false);
// 		}
// 	};
// 	const [childEntityList, setChildEntityList] = useState<any>({});
// 	const [childEntityLoading, setChildEntityLoading] = useState(false);
// 	const getEntityList = async (
// 		id: string,
// 		entity_parent: any,
// 		search_text: string
// 	) => {
// 		if (id) {
// 			let payload = {
// 				entity_group: id,
// 				entity_parent: entity_parent,
// 				limit: 10,
// 				search_text: search_text,
// 			};
// 			let queryRequest = QueryRequestHelper(payload);
// 			setChildEntityLoading(true);
// 			try {
// 				let resp = await getChildEntityGroups(queryRequest);
// 				if (resp) {
// 					levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
// 						(item: any) => ({
// 							...item,
// 							value: getValue(item, `entity_name`, ""),
// 							label: getValue(item, `entity_name`, ""),
// 						})
// 					);
// 					setLevelObj({ ...levelObj });
// 					setChildEntityLoading(false);
// 				} else {
// 					setChildEntityLoading(false);
// 				}
// 			} catch (error) {
// 				setChildEntityLoading(false);
// 			}
// 		} else {
// 			// toast.error("You have Reached Maximum Levels");
// 		}
// 	};
// 	const handleClickEntity = (
// 		entity_id: any,
// 		group_id: any,
// 		group_level: any,
// 		headerIndex: number
// 	) => {
// 		//user selected level
// 		let userLevel = `${entity_id}_${group_id}_${group_level}`;
// 		let payload = { ...paramsObj };
// 		let selectedLevels =
// 			Object.values(payload).length > 0 ? Object.values(payload) : [];
// 		if (!selectedLevels.includes(userLevel)) {
// 			// appending child entity list that are presented in URL Params
// 			var result = Object.entries(childEntityList);
// 			var myNewArray: any =
// 				getValue(result, `length`, 0) > 0
// 					? result.filter(function (item, index) {
// 							return index + 1 <= group_level;
// 					  })
// 					: [];
// 			let obj: any = {};
// 			if (getValue(myNewArray, `length`, 0) > 0) {
// 				myNewArray.map((item: any) => {
// 					obj[item[0]] = item[1];
// 				});
// 			}
// 			setChildEntityList(obj);

// 			//deleting params if grater then current level selected by the user
// 			for (let i = group_level + 1; i < 10; i++) {
// 				delete paramsObj[`level${i}`];
// 			}

// 			// replacing url param if it have same group level / else we can add new one
// 			let checkIfAlreadyExist =
// 				Object.keys(payload).length > 0
// 					? Object.keys(payload).includes(`level${group_level}`)
// 					: false;
// 			if (checkIfAlreadyExist) {
// 				delete paramsObj[`level${group_level}`];
// 				let obj = {
// 					...paramsObj,
// 					// checkpoint_id: selectedIDs,
// 					[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
// 				};
// 				setParamsObj(obj);
// 				getHeaderList(obj, headerIndex);
// 				// let queryRequest = QueryRequestHelper(obj);
// 				// navigate(`${window.location.pathname}?${queryRequest}`);
// 			} else {
// 				let obj = {
// 					...paramsObj,
// 					// checkpoint_id: selectedIDs,
// 					[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
// 				};
// 				setParamsObj(obj);
// 				getHeaderList(obj, headerIndex);
// 				// let queryRequest = QueryRequestHelper(obj);
// 				// navigate(`${window.location.pathname}?${queryRequest}`);
// 			}
// 		} else {
// 			// toast.error("Already selected");
// 		}
// 	};
// 	const handleChange = (
// 		val: string,
// 		entity_group: string,
// 		parent_level: any,
// 		index: number
// 	) => {
// 		let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
// 			? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
// 					"_"
// 			  )[0]
// 			: null;

// 		if (!val) {
// 			getEntityList(entity_group, entityID, "");
// 			let length = Object.keys(paramsObj).length;
// 			for (let i = parent_level; i <= length; i++) {
// 				delete paramsObj[`level${i}`];
// 			}
// 			let obj = {
// 				...paramsObj,
// 				// checkpoint_id: selectedIDs,
// 			};
// 			setParamsObj(obj);
// 			getHeaderList(obj, index);
// 			// let queryRequest = QueryRequestHelper(obj);
// 			// navigate(`${window.location.pathname}?${queryRequest}`);
// 		} else {
// 			getEntityList(entity_group, entityID, val);
// 		}
// 	};
// 	// console.log(levelObj)
// 	// const getHeaderList = async () => {
// 	// 	const urlSearchParams = new URLSearchParams(window.location.search);
// 	// 	const params = Object.fromEntries(urlSearchParams.entries());
// 	// 	let payload: any = {
// 	// 		status: params.status ? params.status : "",
// 	// 		sort_by: params.sort_by,
// 	// 	};
// 	// 	let queryRequest = QueryRequestHelper(payload);
// 	// 	// setHeaderLoading(true);
// 	// 	try {
// 	// 		let resp = await getEntityGroups(queryRequest);
// 	// 		if (resp) {
// 	// 			setHeaderList(getValue(resp, `data.entityGroups`, []));
// 	// 			delete params[`checkpoint_id[]`];
// 	// 			let list =
// 	// 				Object.values(params).length > 0 ? Object.values(params) : [];
// 	// 			if (getValue(list, `length`, 0) > 0) {
// 	// 				getEntityList(
// 	// 					getValue(params, `level1`, "").split("_")[1],

// 	// 					`level${getValue(
// 	// 						resp,
// 	// 						`data.entityGroups[${0}].group_level`,
// 	// 						""
// 	// 					)}` === `level1`
// 	// 						? ""
// 	// 						: getValue(params, `level1`, "").split("_")[0],
// 	// 					""
// 	// 				);
// 	// 				list.map((item: any, _index: number) => {
// 	// 					let findNextLevelInfo = getValue(
// 	// 						resp,
// 	// 						`data.entityGroups`,
// 	// 						[]
// 	// 					).filter(
// 	// 						(ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
// 	// 					);
// 	// 					return getEntityList(
// 	// 						getValue(findNextLevelInfo, `[${0}].id`, ""),
// 	// 						item.split("_")[0],
// 	// 						""
// 	// 					);
// 	// 				});
// 	// 			} else {
// 	// 				getEntityList(
// 	// 					getValue(resp, `data.entityGroups[${0}].id`, ""),
// 	// 					null,
// 	// 					""
// 	// 				);
// 	// 			}
// 	// 			setHeaderLoading(false);
// 	// 		} else {
// 	// 			setHeaderLoading(false);
// 	// 		}
// 	// 	} catch (error) {
// 	// 		setHeaderLoading(false);
// 	// 	}
// 	// };
// 	// const getEntityList = async (
// 	// 	id: string,
// 	// 	entity_parent: any,
// 	// 	search_text: string
// 	// ) => {
// 	// 	if (id) {
// 	// 		let payload = {
// 	// 			entity_group: id,
// 	// 			entity_parent: entity_parent,
// 	// 			limit: 10,
// 	// 			search_text: search_text,
// 	// 		};
// 	// 		let queryRequest = QueryRequestHelper(payload);
// 	// 		setChildEntityLoading(true);
// 	// 		try {
// 	// 			let resp = await getChildEntityGroups(queryRequest);
// 	// 			if (resp) {
// 	// 				childEntityList[id] = getValue(resp, `data.entityMapping`, []).map(
// 	// 					(item: any) => ({
// 	// 						...item,
// 	// 						value: getValue(item, `entity_name`, ""),
// 	// 						label: getValue(item, `entity_name`, ""),
// 	// 					})
// 	// 				);
// 	// 				// setParent_index(null);
// 	// 				// setParent_info({});
// 	// 				// setEditEntity(false);
// 	// 				setChildEntityList({ ...childEntityList });
// 	// 				setChildEntityLoading(false);
// 	// 			} else {
// 	// 				setChildEntityLoading(false);
// 	// 			}
// 	// 		} catch (error) {
// 	// 			setChildEntityLoading(false);
// 	// 		}
// 	// 	} else {
// 	// 		// toast.error("You have Reached Maximum Levels");
// 	// 	}
// 	// };
// 	/* -----------------------------  Executor  ------------------------------ */

// 	const [executorList, setExecutorList] = useState([]);
// 	const [executorLoading, setExecutorLoading] = useState(false);
// 	const [selectedExecutor, setSelectedExecutor] = useState<any>("");
// 	const getExecutorList = async (search: string) => {
// 		try {
// 			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
// 			let payload: any = {
// 				page_no: 1,
// 				page_size: 10,
// 				search_text: search,
// 				user_type: "CLIENT",
// 				org_id: getValue(user, `org_id`, ""),
// 			};
// 			let queryRequest = QueryRequestHelper(payload);
// 			setExecutorLoading(true);
// 			let resp = await adminGetUsers(queryRequest);
// 			if (resp) {
// 				setExecutorLoading(false);
// 				setExecutorList(
// 					getValue(resp, `data.users`, []).map((item: any) => ({
// 						...item,
// 						value:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 						label:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 					}))
// 				);
// 			} else {
// 				setExecutorLoading(false);
// 			}
// 		} catch (error) {
// 			setExecutorLoading(false);
// 		}
// 		if (!search) {
// 			setSelectedExecutor("");
// 		}
// 	};

// 	/* --------------------------------  Evaluator  ------------------------------ */
// 	const [evaluatorList, setEvaluatorList] = useState([]);
// 	const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
// 	const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
// 	const getEvaluator = async (search: string) => {
// 		try {
// 			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
// 			let payload: any = {
// 				page_no: 1,
// 				page_size: 10,
// 				search_text: search,
// 				user_type: "CLIENT",
// 				org_id: getValue(user, `org_id`, ""),
// 			};
// 			let queryRequest = QueryRequestHelper(payload);
// 			setEvaluatorLoading(true);
// 			let resp = await adminGetUsers(queryRequest);
// 			if (resp) {
// 				setEvaluatorLoading(false);
// 				setEvaluatorList(
// 					getValue(resp, `data.users`, []).map((item: any) => ({
// 						...item,
// 						value:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 						label:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 					}))
// 				);
// 			} else {
// 				setEvaluatorLoading(false);
// 			}
// 		} catch (error) {
// 			setEvaluatorLoading(false);
// 		}
// 		if (!search) {
// 			setSelectedEvaluator("");
// 		}
// 	};
// 	/* -----------------------------  FunctionHead  ------------------------------ */
// 	const [FunctionHead, setFunctionHead] = useState([]);
// 	const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
// 	const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
// 	const getFunctionHead = async (search: string) => {
// 		try {
// 			let user: any = JSON.parse(getValue(localStorage, `user`, ""));
// 			let payload: any = {
// 				page_no: 1,
// 				page_size: 10,
// 				search_text: search,
// 				user_type: "CLIENT",
// 				org_id: getValue(user, `org_id`, ""),
// 			};
// 			let queryRequest = QueryRequestHelper(payload);
// 			setFunctionHeadLoading(true);
// 			let resp = await adminGetUsers(queryRequest);
// 			if (resp) {
// 				setFunctionHeadLoading(false);
// 				setFunctionHead(
// 					getValue(resp, `data.users`, []).map((item: any) => ({
// 						...item,
// 						value:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 						label:
// 							getValue(item, `first_name`, "") +
// 							" " +
// 							getValue(item, `last_name`, ""),
// 					}))
// 				);
// 			} else {
// 				setFunctionHeadLoading(false);
// 			}
// 		} catch (error) {
// 			setFunctionHeadLoading(false);
// 		}
// 		if (!search) {
// 			setSelectedFunctionHead("");
// 		}
// 	};

// 	/* -----------------------------  Submit  ------------------------------ */

// 	const handleSubmit = async () => {
// 		const formValid = simpleValidator.current.allValid();
// 		if (!formValid) {
// 			simpleValidator.current.showMessages();
// 			forceUpdate(1);
// 		} else {
// 			const urlSearchParams = new URLSearchParams(window.location.search);
// 			let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
// 			// delete urlParams[`checkpoint_id[]`];
// 			let lengthOfLevels = Object.keys(paramsObj).length;
// 			let levelObj: any = {};
// 			for (let i = 0; i < lengthOfLevels; i++) {
// 				levelObj[`level_${i + 1}`] = paramsObj[`level${i + 1}`]
// 					? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
// 					: "";
// 			}
// 			try {
// 				let payload = {
// 					checkpoint_ids: selectedIDs,
// 					executor: getValue(selectedExecutor, `id`, ""),
// 					evaluator: getValue(selectedEvaluator, `id`, ""),
// 					function_head: getValue(selectedFunctionHead, `id`, ""),
// 				};
// 				setSubmitLoading(true);
// 				let resp = await addSelfComplianceList({ ...payload, ...levelObj });
// 				if (resp) {
// 					toast.success(getValue(resp, `message`, ""));
// 					setSubmitLoading(false);
// 					navigate(`/repository/checkpoint/assigned-tasks`);
// 				} else {
// 					setSubmitLoading(false);
// 				}
// 			} catch (error) {
// 				setSubmitLoading(false);
// 			}
// 		}
// 	};

// 	/* -------------------------------------------------------------------------- */
// 	/*                               Onchange section                             */
// 	/* -------------------------------------------------------------------------- */
// 	const handleReset = () => {
// 		// delete urlParams[`checkpoint_id[]`];
// 		// let payload = {
// 		// 	checkpoint_id: selectedIDs,
// 		// };
// 		// let queryRequest = QueryRequestHelper(payload);
// 		// navigate(`${window.location.pathname}?${queryRequest}`);
// 		setParamsObj({})
// 		setSelectedExecutor('')
// 		setSelectedEvaluator('')
// 		setSelectedFunctionHead('')
// 	};

// 	// const handleClickEntity = (
// 	// 	entity_id: any,
// 	// 	group_id: any,
// 	// 	group_level: any
// 	// ) => {
// 	// 	const urlSearchParams = new URLSearchParams(window.location.search);
// 	// 	const params = Object.fromEntries(urlSearchParams.entries());

// 	// 	//user selected level
// 	// 	let userLevel = `${entity_id}_${group_id}_${group_level}`;
// 	// 	let payload = { ...params };
// 	// 	let selectedLevels =
// 	// 		Object.values(payload).length > 0 ? Object.values(payload) : [];
// 	// 	if (!selectedLevels.includes(userLevel)) {
// 	// 		// appending child entity list that are presented in URL Params
// 	// 		var result = Object.entries(childEntityList);
// 	// 		var myNewArray: any =
// 	// 			getValue(result, `length`, 0) > 0
// 	// 				? result.filter(function (item, index) {
// 	// 						return index + 1 <= group_level;
// 	// 				  })
// 	// 				: [];
// 	// 		let obj: any = {};
// 	// 		if (getValue(myNewArray, `length`, 0) > 0) {
// 	// 			myNewArray.map((item: any) => {
// 	// 				obj[item[0]] = item[1];
// 	// 			});
// 	// 		}
// 	// 		setChildEntityList(obj);

// 	// 		//deleting params if grater then current level selected by the user
// 	// 		for (let i = group_level + 1; i < 10; i++) {
// 	// 			delete params[`level${i}`];
// 	// 		}

// 	// 		// replacing url param if it have same group level / else we can add new one
// 	// 		let checkIfAlreadyExist =
// 	// 			Object.keys(payload).length > 0
// 	// 				? Object.keys(payload).includes(`level${group_level}`)
// 	// 				: false;
// 	// 		delete params[`checkpoint_id[]`];
// 	// 		if (checkIfAlreadyExist) {
// 	// 			delete params[`level${group_level}`];
// 	// 			let obj = {
// 	// 				...params,
// 	// 				checkpoint_id: selectedIDs,
// 	// 				[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
// 	// 			};
// 	// 			let queryRequest = QueryRequestHelper(obj);
// 	// 			navigate(`${window.location.pathname}?${queryRequest}`);
// 	// 		} else {
// 	// 			let obj = {
// 	// 				...params,
// 	// 				checkpoint_id: selectedIDs,
// 	// 				[`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
// 	// 			};
// 	// 			let queryRequest = QueryRequestHelper(obj);
// 	// 			navigate(`${window.location.pathname}?${queryRequest}`);
// 	// 		}
// 	// 	} else {
// 	// 		// toast.error("Already selected");
// 	// 	}
// 	// };

// 	// const handleChange = (
// 	// 	val: string,
// 	// 	entity_group: string,
// 	// 	parent_level: any
// 	// ) => {
// 	// 	const urlSearchParams = new URLSearchParams(window.location.search);
// 	// 	const params = Object.fromEntries(urlSearchParams.entries());
// 	// 	let entityID = getValue(params, `level${parseInt(parent_level) - 1}`, "")
// 	// 		? getValue(params, `level${parseInt(parent_level) - 1}`, "").split("_")[0]
// 	// 		: null;

// 	// 	if (!val) {
// 	// 		getEntityList(entity_group, entityID, "");
// 	// 		delete params[`checkpoint_id[]`];
// 	// 		let length = Object.keys(params).length;
// 	// 		for (let i = parent_level; i <= length; i++) {
// 	// 			delete params[`level${i}`];
// 	// 		}
// 	// 		let obj = {
// 	// 			...params,
// 	// 			checkpoint_id: selectedIDs,
// 	// 		};
// 	// 		let queryRequest = QueryRequestHelper(obj);
// 	// 		navigate(`${window.location.pathname}?${queryRequest}`);
// 	// 	} else {
// 	// 		getEntityList(entity_group, entityID, val);
// 	// 	}
// 	// };

// 	const urlSearchParams = new URLSearchParams(window.location.search);
// 	const urlParams = Object.fromEntries(urlSearchParams.entries());

// 	let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
// 	return (
// 		<>
// 			<Layout>
// 				{!headerLoading &&
// 				!getValue(props, `subTabPermissionList`, []).includes(
// 					"checkpoint_assigned_tasks"
// 				) ? (
// 					<NoAccessPage />
// 				) : (
// 					<>
// 						<div className="common-sticky-header">
// 							<section className="inner-page-navigation-with-back-cta-buttons position-relative">
// 								<div className="container-fluid  d-flex justify-content-between align-items-center">
// 									<div className="d-flex align-items-center">
// 										<NavLink to="/repository/checkpoint/master">
// 											<img
// 												src="/images/back-link.svg"
// 												className="img-fluid"
// 												height={24}
// 												width={24}
// 											/>
// 										</NavLink>
// 										<p className="inner-page-navigation-text py-3">
// 											Assign Task
// 										</p>
// 									</div>
// 								</div>
// 							</section>
// 						</div>
// 						<div className="release-checkpoint  d-flex justify-content-between align-items-center">
// 							<h4>Selected {getValue(selectedIDs, `length`, 0)} Checkpoints</h4>
// 							{getValue(props, `permissions`, []).includes("update") && (
// 								<div>
// 									<button
// 										className="ascent-button ascent-button--header-buttons ascent-button--primary"
// 										onClick={handleReset}
// 									>
// 										{"Reset"}
// 									</button>
// 									&nbsp;&nbsp;
// 									<button
// 										className="ascent-button ascent-button--header-buttons ascent-button--secondary"
// 										onClick={handleSubmit}
// 										disabled={submitLoading}
// 									>
// 										{submitLoading ? "Please wait..." : "Assign"}
// 									</button>
// 								</div>
// 							)}
// 						</div>
// 						{
// 							<>
// 								{/* Step 1 */}
// 								<div className="map-vendor-wrapper w-100">
// 									<div className="map-vendor__details d-flex align-items-flex-start m-0">
// 										<div className="map-vendor__check">
// 											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
// 												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
// 													Step 1
// 												</h5>
// 												<div className="form-group d-flex align-iems-center m-0"></div>
// 											</div>
// 											<div className="map-vendor__checklist my-3">
// 												{headerLoading || !props.permissionAPITriggered ? (
// 													<Loader />
// 												) : getValue(headerList, `length`, 0) > 0 ? (
// 													headerList.map((searchObj, index) => {
// 														let selectedLevel =
// 															getValue(searchObj, `group_level`, 0) > 0
// 																? getValue(
// 																		paramsObj,
// 																		`level${parseInt(
// 																			getValue(searchObj, `group_level`, "")
// 																		)}`,
// 																		""
// 																  )
// 																: "";
// 														let currentSelectedItem =
// 															selectedLevel.split("_")[0];
// 														let selectedValue =
// 															getValue(
// 																levelObj,
// 																`[${getValue(searchObj, `id`, "")}].length`,
// 																[]
// 															) > 0 &&
// 															getValue(
// 																levelObj,
// 																`[${getValue(searchObj, `id`, "")}]`,
// 																[]
// 															).filter(
// 																(item: any) =>
// 																	item.id === parseInt(currentSelectedItem)
// 															);
// 														return (
// 															<>
// 																<div className={`d-flex cursor-pointer`}>
// 																	<div
// 																		className="position-relative form-group  align-items-center cursor-pointer mb-0"
// 																		key={`location-${index}`}
// 																	>
// 																		<div>
// 																			{getValue(searchObj, `group_name`, "")}
// 																		</div>
// 																		<div>
// 																			<div className="filter-form-wrappper__location-input">
// 																				<SearchableDropdownSelect
// 																					placeholder={`Choose ${getValue(
// 																						searchObj,
// 																						`group_name`,
// 																						""
// 																					)}`}
// 																					options={getValue(
// 																						levelObj,
// 																						`[${getValue(
// 																							searchObj,
// 																							`id`,
// 																							""
// 																						)}]`,
// 																						[]
// 																					)}
// 																					searchLoading={false}
// 																					handleChange={(val: any) =>
// 																						handleChange(
// 																							val,
// 																							getValue(searchObj, `id`, ""),
// 																							getValue(
// 																								searchObj,
// 																								`group_level`,
// 																								""
// 																							),
// 																							index
// 																						)
// 																					}
// 																					handleClick={(e: any) =>
// 																						handleClickEntity(
// 																							getValue(e, `id`, ""),
// 																							getValue(searchObj, `id`, ""),
// 																							getValue(
// 																								searchObj,
// 																								`group_level`,
// 																								""
// 																							),
// 																							index
// 																						)
// 																					}
// 																					value={
// 																						getValue(
// 																							selectedValue,
// 																							`length`,
// 																							0
// 																						) > 0
// 																							? selectedValue[0]
// 																							: ""
// 																					}
// 																					label="label"
// 																					id="id"
// 																					name={getValue(
// 																						searchObj,
// 																						`group_name`,
// 																						""
// 																					)}
// 																					// removeClose
// 																					validator={simpleValidator}
// 																				/>
// 																			</div>
// 																		</div>
// 																	</div>
// 																</div>
// 																<br />
// 															</>
// 														);
// 													})
// 												) : (
// 													<>
// 														{Object.keys(params).length !== 0 ? (
// 															<>
// 																<Notfound />
// 															</>
// 														) : (
// 															<Notfound />
// 														)}
// 													</>
// 												)}
// 											</div>
// 										</div>
// 										{/* Step 2 */}
// 										<div className="map-vendor__check">
// 											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
// 												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
// 													Step 2
// 												</h5>
// 												<div className="form-group d-flex align-iems-center m-0"></div>
// 											</div>
// 											<div className=" my-3">
// 												<div className=" d-flex">
// 													<div className="position-relative form-group  align-items-center cursor-pointer mb-0">
// 														<div>
// 															<label>Executor *</label>
// 															<SearchableDropdownSelect
// 																placeholder={"Search Executor"}
// 																options={executorList}
// 																searchLoading={executorLoading}
// 																handleChange={(val: any) =>
// 																	getExecutorList(val)
// 																}
// 																handleClick={(e: any) => setSelectedExecutor(e)}
// 																value={selectedExecutor}
// 																label="label"
// 																id="id"
// 																name="Executor"
// 																validator={simpleValidator}
// 															/>
// 														</div>
// 														<br />
// 														<div>
// 															<label>Evaluator *</label>
// 															<SearchableDropdownSelect
// 																placeholder={"Search Evaluator"}
// 																options={evaluatorList}
// 																searchLoading={EvaluatorLoading}
// 																handleChange={(val: any) => getEvaluator(val)}
// 																handleClick={(e: any) =>
// 																	setSelectedEvaluator(e)
// 																}
// 																value={selectedEvaluator}
// 																label="label"
// 																id="id"
// 																name="Evaluator"
// 																validator={simpleValidator}
// 															/>
// 														</div>
// 														<br />
// 														<div>
// 															<label>Function Head *</label>
// 															<SearchableDropdownSelect
// 																placeholder={"Search Function Head"}
// 																options={FunctionHead}
// 																searchLoading={FunctionHeadLoading}
// 																handleChange={(val: any) =>
// 																	getFunctionHead(val)
// 																}
// 																handleClick={(e: any) =>
// 																	setSelectedFunctionHead(e)
// 																}
// 																value={selectedFunctionHead}
// 																label="label"
// 																id="id"
// 																name="Function Head"
// 																validator={simpleValidator}
// 															/>
// 														</div>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 								<div className="footer-wrapper-new w-100">
// 									<img
// 										src="/images/footer-image.svg"
// 										className="img-fluid footer-image"
// 									/>
// 								</div>
// 							</>
// 						}
// 					</>
// 				)}
// 			</Layout>
// 		</>
// 	);
// }
